<template>
  <search-custom-dropdown
    v-model="searchInput.includeBtn.state"
    :search-input-text="searchInput.includeBtn.text"
    :is-filled="isFilled()"
    :width="50"
  >
    <template v-slot:drop-content>
      <checkbox-list-selector
        checkbox-group-title="Type of listings"
        :checkbox-options="searchOptions.listingOptions"
        :pre-selected="selectedListings"
        @update-selection="updateCheckboxSelections($event, 'includeBtn', 'Include')"
      />
    </template>
  </search-custom-dropdown>
</template>

<script>
import searchLayoutHandler from '../../mixins/searchLayoutHandler'
import { isEmpty } from '../../../utils/generalUtils'

export default {
  mixins: [searchLayoutHandler],

  methods: {
    isFilled() {
      if (!this.isRentType) {
        if (this.lastNewQuery.query.Status.includes('Pending')) return true
        if (
          isEmpty(this.lastNewQuery.query.Foreclosure) ||
          this.lastNewQuery.query.Foreclosure === true
        ) { return true }
      }
      return false
    }
  }
}
</script>

<style>
</style>
